"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRevenueImpactDashboardCreatedPipeline = exports.updateRevenueImpactDashboardAccess = exports.updateDashboardAccess = exports.updateDomainsFail = exports.updateDomainsSuccess = exports.updateDomainsRequest = exports.securityLoadFail = exports.securityLoadSuccess = exports.securityLoadRequest = exports.toggleForceSsoFail = exports.toggleForceSsoSuccess = exports.toggleForceSsoRequest = void 0;

var _reduxAct = require("redux-act");

var _utils = require("@alycecom/utils");

var PREFIX = 'COMMON/SETTINGS';
var toggleForceSsoRequest = (0, _reduxAct.createAction)("".concat(PREFIX, "/TOGGLE_FORCE_SSO_REQUEST"));
exports.toggleForceSsoRequest = toggleForceSsoRequest;
var toggleForceSsoSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/TOGGLE_FORCE_SSO_SUCCESS"));
exports.toggleForceSsoSuccess = toggleForceSsoSuccess;
var toggleForceSsoFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/TOGGLE_FORCE_SSO_FAIL"));
exports.toggleForceSsoFail = toggleForceSsoFail;
var securityLoadRequest = (0, _reduxAct.createAction)("".concat(PREFIX, "/SECURITY_LOAD_REQUEST"));
exports.securityLoadRequest = securityLoadRequest;
var securityLoadSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SECURITY_LOAD_SUCCESS"));
exports.securityLoadSuccess = securityLoadSuccess;
var securityLoadFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SECURITY_LOAD_FAIL"));
exports.securityLoadFail = securityLoadFail;
var updateDomainsRequest = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_DOMAINS_REQUEST"));
exports.updateDomainsRequest = updateDomainsRequest;
var updateDomainsSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_DOMAINS_SUCCESS"));
exports.updateDomainsSuccess = updateDomainsSuccess;
var updateDomainsFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_DOMAINS_FAIL"));
exports.updateDomainsFail = updateDomainsFail;
var updateDashboardAccess = (0, _utils.createAsyncAction)("".concat(PREFIX, "/UPDATE_DASHBOARD_ACCESS"));
exports.updateDashboardAccess = updateDashboardAccess;
var updateRevenueImpactDashboardAccess = (0, _utils.createAsyncAction)("".concat(PREFIX, "/UPDATE_REVENUE_IMPACT_DASHBOARD_ACCESS"));
exports.updateRevenueImpactDashboardAccess = updateRevenueImpactDashboardAccess;
var updateRevenueImpactDashboardCreatedPipeline = (0, _utils.createAsyncAction)("".concat(PREFIX, "/UPDATE_REVENUE_IMPACT_DASHBOARD_CREATED_PIPELINE"));
exports.updateRevenueImpactDashboardCreatedPipeline = updateRevenueImpactDashboardCreatedPipeline;